import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { API_URL } from "../../config";
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard10() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: 'user_name_surname',
    direction: 'ascending',
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    axios
      .get(`${API_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }, { withCredentials: true })
      .then((response) => {
        setUserData(response.data);
        logAuditUI({
          actionType: 'VIEW_LIST',
          module: 'Utilizatori',
          description: 'A accesat lista de utilizatori',
          details: { count: Array.isArray(response.data) ? response.data.length : 0 },
        });
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, []);

  const sortedData = [...userData].sort((a, b) => {
    if (sortConfig.key && a[sortConfig.key] !== undefined && b[sortConfig.key] !== undefined) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending" ? aValue - bValue : bValue - aValue;
      } else if (sortConfig.key === "created_timestamp") {
        return sortConfig.direction === "ascending"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
    }
    return 0;
  });

  const uniqueData = sortedData.reduce((acc, item) => {
    if (!acc.some(existingItem => existingItem.user_name_surname === item.user_name_surname)) {
      acc.push(item);
    }
    return acc;
  }, []);

  const handleEditRows = (item) => {
    //////////////////////////////console.log(item);

    navigate("/users/aboutuser", { state: { item, fromUserManagement: true } });
  };

  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 15; // Schimbă după preferințe
  const [currentPage, setCurrentPage] = useState(1);
  const total = uniqueData.filter((user) => user.user_name_surname.toLowerCase().includes(searchQuery1.toLowerCase()))

  const totalPages = Math.ceil(total.length / itemsPerPage);
  // Elemente curente pe baza paginii
  const currentItems = total.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNewRows = (item) => {
    //////////////////////////////console.log(item);

    navigate("/users/createuser");
  };

  return (
    <>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <>
          <div
            className=" col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl justify-center items-center w-full md:w-[800px] "
          >
            <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
              <div className="relative">
                <h1 className="text-2xl md:text-2xl text-gray-800 dark:text-gray-100 font-bold">Utilizatorii CRM</h1>
              </div>

              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto">
                <div className="relative w-full sm:w-64 md:w-80">
                  <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200"
                    placeholder="Căutare utilizator"
                    value={searchQuery1}
                    onChange={(e) => setSearchQuery1(e.target.value)} />
                </div>

                <div className="relative">
                  <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0" onClick={handleNewRows}>
                    {/* <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg> */}
                    <span className="//max-xs:sr-only">Adauga utilizator</span>
                  </button>
                </div>
              </div>
            </header>
            <div className="p-2 flex justify-center items-center h-full w-full"> {/* Adăugat flex, justify-center, items-center */}
              <div className="overflow-x-auto w-full max-w-10xl"> {/* max-width pentru a limita lățimea */}
                <table className="table-auto w-full">
                  <thead className="text-xs font-semibold uppercase text-gray-700 dark:text-white bg-gray-100 dark:bg-gray-800 ">
                    <tr>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "user_name_surname",
                          direction: prevConfig.key === "user_name_surname" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Nume Prenume
                          {sortConfig.key === "user_name_surname" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "is_active",
                          direction: prevConfig.key === "is_active" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Statut
                          {sortConfig.key === "is_active" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "created_timestamp",
                          direction: prevConfig.key === "created_timestamp" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Timpul ultimei modificari
                          {sortConfig.key === "created_timestamp" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell">
                        <div className="flex items-center gap-2">
                          Posta electronica
                        </div>
                      </th>
                      <th className="p-3 whitespace-nowrap cursor-pointer">
                        <div className="flex items-center gap-2">
                          Telefon
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems
                      .map((customer, index) => {
                        return (
                          <tr key={customer.user_id}
                            className={`${index % 2 === 0 ? 'bg-gray-0 dark:bg-gray-800' : 'bg-gray-100 dark:bg-gray-700'} hover:bg-gray-200 dark:hover:bg-gray-600`}
                            onClick={() => {
                              handleEditRows(customer);
                            }}
                            role="button"
                          >
                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left">{customer.user_name_surname}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap">
                              <div className={`text-left font-medium ${customer.is_active ? 'text-green-500' : 'text-red-500'}`}>
                                {customer.is_active ? "Activ" : "Inactiv"}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                              <div className="text-left">
                                {customer.created_timestamp &&
                                  dayjs(customer.created_timestamp).format("DD-MM-YYYY")}
                              </div>
                            </td>

                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                              <div className="text-left">{customer.mail ? customer.mail : "no data"}</div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left">{customer.phone ? "+373 " + customer.phone : "no data"}</div>
                            </td>
                          </tr>
                        );
                      })}

                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-center mt-4 mb-4 //sticky bottom-0">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {currentPage > 3 && (
                <>
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    1
                  </button>
                  <span className="px-2">...</span>
                </>
              )}

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                if (
                  page === currentPage ||
                  // page === 1 ||
                  // page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
                ) {
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-4 py-2 text-sm font-medium ${currentPage === page
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {currentPage < totalPages - 2 && (
                <>
                  <span className="px-2">...</span>
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    {totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DashboardCard10;
